import { echoTool } from './common';
import { wordTools } from './word';
import { outlookTools } from './outlook';
import { powerpointTools } from './powerpoint';
import { excelTools } from './excel';
export function getToolsForHost(hostType) {
    const tools = [echoTool];
    switch (hostType) {
        case 'word':
            tools.push(...wordTools);
            break;
        case 'outlook':
            tools.push(...outlookTools);
            break;
        case 'powerpoint':
            tools.push(...powerpointTools);
            break;
        case 'excel':
            tools.push(...excelTools);
            break;
    }
    return tools;
}
